<template>
  <!-- 导出按钮 -->
  <el-button
    class="export_btn"
    type="primary"
    size="mini"
    plain
    @click="exportList"
    >导出</el-button
  >
</template>

<script>
export default {
  props: {
    params: Object,
    url: String
  },
  data() {
    return {};
  },
  methods: {
    // 导出列表
    exportList() {
      let aNode = document.createElement("a"),
        base_url = this.$api.base_url;
      if (process.env.NODE_ENV === "development") base_url = "";
      aNode.href = base_url + this.url + this.getQuery();
      aNode.style.display = "none";
      document.body.appendChild(aNode);
      aNode.click();
    },
    getQuery() {
      let query = "";
      Object.keys(this.params).forEach(key => {
        if (this.params[key]) {
          if (query) {
            query += `&${key}=${this.params[key]}`;
          } else {
            query = `?${key}=${this.params[key]}`;
          }
        }
      });
      return query;
    }
  }
};
</script>

<style lang="less" scoped>
.export_btn {
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/identify/components/exportBtn.vue